import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Entities } from 'src/app/core/models/globals';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { HeaderService } from '../../../../core/services/header.service';

@Component({
  selector: 'app-user-main-panel',
  templateUrl: './user-main-panel.component.html',
  styleUrls: ['./user-main-panel.component.scss']
})
export class UserMainPanelComponent implements OnInit {

  lastRefreshedTime: Date; // time when data is loaded/refreshed

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navService: NavigationService,
    private headerService: HeaderService
  ) { }

  ngOnInit(): void {
    this.navService.subNavData(Entities.Users)
    this.navService.sendLastUpdate(this.headerService.getUserNewDate());
    this.navService.lastUpdateTime.subscribe(x => {
      this.lastRefreshedTime = x
    })
  }

  refreshComponent(){
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
  }); 
  }
  

}
